import { render, staticRenderFns } from "./commendView.vue?vue&type=template&id=534ac3a8&"
import script from "./commendView.vue?vue&type=script&lang=js&"
export * from "./commendView.vue?vue&type=script&lang=js&"
import style0 from "./commendView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports